import React from 'react';

// Material Symbols Rounded icon by ligature name, e.g. <Icon name="add" />
const Icon = ({ name, size = 20, color, filled = false, style, className = '' }) => (
    <span
        className={`ls-icon ${className}`}
        aria-hidden="true"
        style={{
            fontSize: size,
            color,
            fontVariationSettings: filled ? "'FILL' 1" : undefined,
            ...style,
        }}
    >
        {name}
    </span>
);

export default Icon;
